// i18n area 'apps' — locale pt-BR (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da apps.pt-PT.ts e sovrascrive SOLO le chiavi
// che il brasiliano scrive davvero in un altro modo: lessico (usuário,
// arquivo, tela, senha, registro, seção, configurações, salvar, console) e
// morfologia verbale (il progressivo 'está a fazer' → 'está fazendo').
// DA RIVEDERE DA MADRELINGUA: restano fuori le scelte a bassa confidenza
// (alojar/hospedar, eliminar/excluir, arranque/inicialização) e la posizione
// dei clitici, che una regola meccanica non sa spostare.
// Sidecar anti-stantie: ../meta/apps.pt-BR.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './apps'

export const ptBR: DeepPartial<typeof enUS> = {
  apps: {
    editImageHint: 'Uma nova referência volta a resolver-se através do registro OCI — o gesto de pin/rollback.'
  },
  cts: {
    // Round #347: il brasiliano scrive 'console' (maschile) dove il portoghese
    // europeo scrive 'a consola' (femminile) — l'accordo si trascina su tutta
    // la frase — e 'tela' dove il pt-PT dice 'ecrã', 'registrar' dove dice
    // 'registar'. Il resto del blocco è identico e resta ereditato.
    console: 'Console',
    consoleUnavailable: 'O container não está em execução — um console precisa de um container vivo. Os seus logs, esses, leem-se em qualquer estado.',
    consoleNoTemplate: 'Um template nunca corre, por isso não tem console: crie um CT a partir dele e abra o desse.',
    consoleTakenBy: 'Outro operador tomou este console ({user}). Um console por container: voltar a ligar traz-lho de volta.',
    consoleStatus: {
      connected: 'Ligado'
    },
    logsSourceConsole: 'O console do init do container — porque o serviço lá dentro não arrancou',
    logsNeverStarted: 'Nunca foi iniciado, por isso ainda não há nada registrado — inicie-o, e os logs lá estarão mesmo que o arranque falhe.',
    logsNoTemplate: 'Um template nunca corre, por isso nunca registrou nada.'
  },
  ctTemplates: {
    importHint: 'Materializar copia o rootfs para o storage escolhido — o arquivo de catálogo fica intacto. Para adicionar novos arquivos, carregue-os primeiro dentro de um catálogo.',
    sourceFile: 'Arquivo de template CT',
    sourceFileHint: 'Os arquivos ct-rootfs do catálogo escolhido, apenas os prontos',
    noFiles: 'Nenhum arquivo ct-rootfs pronto neste catálogo — carregue um a partir da página do catálogo',
    source: 'Arquivo de origem',
    exportHint: 'Empacota o rootfs materializado num NOVO arquivo ct-rootfs no catálogo escolhido — o template fica intacto.',
    exportName: 'Nome do arquivo'
  },
  oci: {
    credentialHint: 'Uma entrada de keystore usuário-e-senha; os workers resolvem-na no momento do uso — nunca arquivos de auth por nó.',
    importCatalogHint: 'A via air-gapped: um arquivo oci-image pronto (tar/tar.gz — docker-archive ou oci-archive) é materializado no store de imagens com a referência catalog/<catálogo>/<file>@<digest>; as apps consomem-no como qualquer outra imagem. Os arquivos carregam-se nos catálogos — esta seção só importa.',
    importCatalogFileHint: 'Os arquivos oci-image prontos do catálogo escolhido.',
    exploreAdded: '{path}:{tag} é agora seguido — veja a seção Repositórios.',
    purgeRequiredBody: 'Nenhuma app consome este repositório, mas ainda existem imagens descarregadas: eliminá-lo remove também os seus registros, e os blobs em cache passam ao garbage collector.',
    noImages: 'Nenhuma imagem deste repositório está materializada no cache.'
  }
}
